
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class LuogoVendita extends Vue {
  @Prop() luogoVendita!: any;
}
